module.exports = __webpack_public_path__ + "static/media/LK__User.1cea2b7e.svg";